import { fetcher } from "helpers/fetcher";

import { TCreateScorecardClientReq, TCreateScorecardClientRes } from "./types";
import { MANAGEMENT_ENDPOINTS } from "./endpoint";
import { API_HEADER } from "api/constants";

export const createScorecardClient = async (
  payload: TCreateScorecardClientReq
) => {
  return await fetcher<
    TCreateScorecardClientRes,
    TCreateScorecardClientReq["data"]
  >(MANAGEMENT_ENDPOINTS.CREATE_SCORECARD_CLIENT, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    data: payload.data,
  });
};

export const mutationCreateScorecardClient = async (
  payload: TCreateScorecardClientReq
) => {
  return (await createScorecardClient(payload)).data;
};

mutationCreateScorecardClient._key = (payload: TCreateScorecardClientReq) => [
  MANAGEMENT_ENDPOINTS.CREATE_SCORECARD_CLIENT.url,
  payload,
];
